/* jshint esversion: 6 */
import axios from 'axios';
import router from '../router'
let apiUrl = "",
    maxServerTime = 35000;
    apiUrl = "/haodaweb/"; //正式环境
try {
  if (DEVELEPMENT) {
    apiUrl = "/api/"; //测试环境
  }
} catch (error) {
  
}

export const baseURL = apiUrl;

import qs from "qs";

axios.defaults.timeout = maxServerTime;//超时时间
axios.defaults.baseURL = baseURL;

//请求头设置
axios.interceptors.request.use((config) => {
  var param = {
    "validateJson":{"accessUser":"haoda","accessPwd":"haoda2019","accessFjm":"haoda","datafrom":"web"},
    "paramJson":{}
  }
  param.validateJson = JSON.stringify(param.validateJson);
  param.paramJson = JSON.stringify(config.data);
  config.data = qs.stringify(param);
  config.headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }
  return config;
}, (error) => {
  // Message.error({message: '请求超时!请检查网络链接'});
  return Promise.reject(error);
});


//返回参数拦截器
axios.interceptors.response.use((response) => {
    if (response.data.code == '200') { //成功，状态码根据接口文档设置
      return response;
    } else {
      // MessageBox.confirm(
      //   response.data.msg,
      //   '提示信息', {
      //     confirmButtonText: '确定',
      //     showCancelButton: false,
      //     type: 'warning'
      //   });
    }

  },
  err => {
        let errMsg = "",
            errCode = "";
        try {
          if (err.response.status == 404) {
            errMsg = "所请求的页面不存在或已被删除！"
          } else if (err.response.status == 403) {
            errMsg = "权限不足,请联系管理员!"
          } else if (err.response.status == 401) {
            errMsg = "未经授权!"
          } else if (err.response.status == 500 || err.response.status == 501 || err.response.status == 502|| err.response.status == 503 || err.response.status == 504 || err.response.status == 505) {//500 501 502 503 504 505
            errMsg = "服务器未响应!"
          } else {
            if (err.response.data.msg) {
              errMsg = err.response.data.msg
            } else {
              errMsg = '未知错误'
            }
          }
          errCode = err.response.status
        } catch (error) {
          errMsg = '未知错误';
          errCode = '404'
        }
        router.push({
          path:"/error",
          query:{
            errCode:errCode || "404",
            errMsg:errMsg
          }
        })
  }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params) {

  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })

}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })

}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}



// WEBPACK FOOTER //
// ./src/utils/request.js